// AddQuestion.js
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Badge, Button, Col, Form, Row, Spinner } from "reactstrap";
import {
  addQuestionAPI,
  approveQuestionAPI,
  deleteQuestionAPI,
  getRejectedQuestionListAPI
} from "../../api/question";
import { updateQuestionAPI } from "../../api/user";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard
} from "../../components/Component";
import useLogout from "../../Hooks/Logout";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import EmailCreatableSelect from "../../MyComponents/Form/EmailCreatableSelect";
import MyButton from "../../MyComponents/Form/MyButton";
import MyCreateSelect from "../../MyComponents/Form/MyCreateSelect";
import MyInput from "../../MyComponents/Form/MyInput";
import MySelect from "../../MyComponents/Form/MySelect";
import MyTextArea from "../../MyComponents/Form/MyTextArea";
import DeleteModal from "../../MyComponents/Modal/DeleteModal";
import ApiPaginationDataTable from "../../MyComponents/MyTables/ApiPaginationDataTable";
import QuestionCountsCards from "./QuestionCountsCards";

const RejectedQuestion = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const[totalRows, setTotalRows] = useState(0);
  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  //   const [data, setData] = useState([

  //   ]);
  const [data, setData] = useState([]);
  const [mode, setMode] = useState("Add");
  const logout = useLogout();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [onSearch, setonSearch] = useState(false);
  const [onSearchText, setSearchText] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      limit: 25,
      isLoading: true,
      topProductLoading: true,
      tableLoading: true,
    },
  });
  const columns = [
    {
      name: "Keyword",
      selector: (row) => row.keyword, // keyword is a string
      wrap: true,
    },
    {
      name: "Category",
      selector: (row) => row.category,
      wrap: true,
    },
    {
      name: "Questions",
      selector: (row) => {
        const joinedQuestions = row.questions.join(", ");
        return (
          <>
            <span className="text-wrap" title={joinedQuestions}>
              {joinedQuestions.length > 25 ? joinedQuestions.substring(0, 25) + "..." : joinedQuestions}
            </span>
          </>
        );
      },
      wrap: true,
    },
    {
      name: "Short Answer",
      selector: (row) => (
        <>
          <span className="  text-wrap  " title={`${row.answer_short}`}>
            {row.answer_short.length > 25 ? row.answer_short.substring(0, 25) + "..." : row.answer_short}
          </span>
        </>
      ),
      wrap: true,
    },
    {
      name: "Detailed Answer",
      selector: (row) => (
        <>
          <span className="  text-wrap  " title={`${row.answer_detail}`}>
            {row.answer_detail.length > 25 ? row.answer_detail.substring(0, 25) + "..." : row.answer_detail}
          </span>
        </>
      ),
      wrap: true,
    },
    {
      name: "Helpline Number",
      selector: (row) => row.contact_info?.helpline_numbers,
      wrap: true,
    },
    {
      name: "Department",
      selector: (row) => row.contact_info?.department,
      wrap: true,
    },
    {
      name: "Email",
      selector: (row) => (row.contact_info?.email || ["N/A"]).join(", "),
      wrap: true,
    },
    {
      name: "Website",
      selector: (row) => row.contact_info?.website,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div className="text-capitalize">
          <Badge color={row.status == "approved" ? "success" : row?.status == "rejected" ? "danger" : "warning"}>
            {row.status == "approved" ? "approved" : row?.status == "rejected" ? "Rejected" : "Pending"}
          </Badge>
        </div>
      ),
      sortable: true,
      // width: "90px",
    },
    // {
    //   name: "Actions",
    //   width: "200px",
    //   cell: (row) => (
    //     <>
    //       {/* <Button className="me-1" outline color="warning" size="xs" onClick={() => handleEdit(row)}>
    //         <Icon name="edit" />
    //       </Button>{" "} */}
    //       <Button className="me-1" outline color="success" size="xs" onClick={() => handleApprove(row)}>
    //         <Icon name="check" />
    //       </Button>{" "}
    //       <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
    //         <Icon name="cross" />
    //       </Button>
    //     </>
    //   ),
    // },
  ];
  const limit = watch("limit");
  const tableLoading = watch("tableLoading");
  // pagination
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setItemPerPage(rows);
    setValue("page", page);
  };
  const handlePageChange = (page) => {
    setValue("page", page);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(onSearchText);
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler);
    };
  }, [onSearchText]);
  // Fetch pending questions
  useEffect(() => {
    const body = {
      search: debouncedSearch,
      page: currentPage,
      limit: itemPerPage,
    };
    getQuestions(body);
  }, [itemPerPage, currentPage, watch("page")]);

  const getQuestions = (data) => {
    setIsLoading(true);
    getRejectedQuestionListAPI(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        if (status === true) {
          const decryptedResponse = res.data.data;
          toast.success(res.data.message);
          console.log("res.", res.data.data);
          setValue("limit", decryptedResponse?.pagination?.total);
          setData(decryptedResponse?.items);
          toast.clearWaitingQueue();
          setIsLoading(false);
        } else if (status === false) {
          setIsLoading(false);
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err);
      });
  };

  // Delete a question
  //   const handleDelete = (id) => {
  //     if (window.confirm("Are you sure you want to delete this question?")) {
  //       deleteQuestionAPI(id)
  //         .then((res) => {
  //           if (res.data.status === true) {
  //             toast.success(res.data.message);
  //             getQuestions();
  //           } else toast.error(res.data.message);
  //         })
  //         .catch((err) => toast.error("Failed to delete question"));
  //     }
  //   };
  const categoryOptions = [
    { value: "Women Safety", label: "Women Safety" },
    { value: "Child Safety", label: "Child Safety" },
    { value: "Health", label: "Health" },
  ];
  const findOption = (options, value) => options.find((opt) => opt.value === value) || null;
  const departmentOptions = [
    { value: "महिला सुरक्षा प्रकोष्ठ", label: "महिला सुरक्षा प्रकोष्ठ" },
    { value: "Child Safety", label: "Child Safety" },
    { value: "Health", label: "Health" },
  ];
  const handleApprove = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    trigger("selectedRow");
    setMode("Approve");
    // Set the question ID
    setValue("questionId", row.id || "");

    // Keyword & Category as plain strings
    setValue("keyword", Array.isArray(row.keyword) ? row.keyword : [row.keyword]);
    setValue("category", Array.isArray(row.category) ? row.category : [row.category]);

    // Questions array of strings
    setValue("questions", Array.isArray(row.questions) ? row.questions : [row.questions]);

    // Helpline numbers as array of strings
    setValue("helpline_numbers", row.contact_info?.helpline_numbers ? row.contact_info.helpline_numbers.split(",") : []);

    // Department as string
    setValue("department", { value: row.contact_info?.department, label: row?.contact_info?.department } || "");

    // Email array of strings
    setValue("email", Array.isArray(row.contact_info?.email) ? row.contact_info.email : []);

    // Website & answers
    setValue("website", row.contact_info?.website || "");
    setValue("answer_short", row.answer_short || "");
    setValue("answer_detail", row.answer_detail || "");
    setIsOpen(true);
  };
  // Edit question
  const handleEdit = (row) => {
    setMode("Edit");
    setIsOpen(true);

    // Set the question ID
    setValue("questionId", row.id || "");

    // Keyword & Category as plain strings
    setValue("keyword", Array.isArray(row.keyword) ? row.keyword : [row.keyword]);
    setValue("category", Array.isArray(row.category) ? row.category : [row.category]);

    // Questions array of strings
    setValue("questions", Array.isArray(row.questions) ? row.questions : [row.questions]);

    // Helpline numbers as array of strings
    setValue(
      "helpline_numbers",
      row.contact_info?.helpline_numbers ? row.contact_info.helpline_numbers.split("/") : [],
    );

    // Department as string
    setValue("department", row.contact_info?.department || "");

    // Email array of strings
    setValue("email", Array.isArray(row.contact_info?.email) ? row.contact_info.email : []);

    // Website & answers
    setValue("website", row.contact_info?.website || "");
    setValue("answer_short", row.answer_short || "");
    setValue("answer_detail", row.answer_detail || "");

    window.scrollTo(0, 0);
  };

  // Form submission
  //   const onFormSubmit = (formData) => {
  //     setIsLoading(true);

  //     const payload = {
  //       id: formData.questionId, // for update
  //       keyword: formData.keyword,
  //       category: formData.category,
  //       questions: formData.questions,
  //       answer_short: formData.answer_short,
  //       answer_detail: formData.answer_detail,
  //       contact_info: {
  //         helpline_numbers: formData.helpline_numbers.join("/"),
  //         department: formData.department,
  //         email: formData.email,
  //         website: formData.website,
  //       },
  //     };

  //     AddQuestionAPI(payload)
  //       .then((res) => {
  //         setIsLoading(false);
  //         if (res.data.status === true) {
  //           toast.success(res.data.message);
  //           getQuestions();
  //           setIsOpen(false);
  //           reset();
  //           setMode("Add");
  //         } else toast.error(res.data.message);
  //       })
  //       .catch((err) => {
  //         setIsLoading(false);
  //         console.error(err);
  //       });
  //   };
  const onFormSubmit = (formData) => {
    console.log(formData, "formData");
    setIsLoading(true);

    // Ensure keyword and category are strings
    const keyword = Array.isArray(formData.keyword) ? formData.keyword[0] : formData.keyword;
    const category = Array.isArray(formData.category) ? formData.category[0] : formData.category;

    const payload = {
      ...(mode=="Edit"||mode=="Approve"&&{id:formData?.questionId}),
      keyword: keyword,
      category: category,
      questions: formData.questions,
      answer_short: formData.answer_short,
      answer_detail: formData.answer_detail,
      contact_info: {
        helpline_numbers: formData.helpline_numbers.join(","),
        department: formData.department.label,
        email: formData.email,
        website: formData.website,
      },
    };

    const apiCall =
      mode === "Add"
        ? addQuestionAPI(payload)
        : mode == "Edit"
          ? updateQuestionAPI(payload)
          : mode == "Approve"
            ? approveQuestionAPI(formData)
            : "";
    // : updateQuestionAPI({ ...payload, id: formData.questionId })

    apiCall
      .then((res) => {
        setIsLoading(false);
        if (res.data.status) {
          const body = {
            search: debouncedSearch,
            page: currentPage,
            limit: itemPerPage,
          };
          toast.success(res.data.message);
          getQuestions(body);
          setData(res);
          setIsOpen(false);
          reset();
          if (mode === "Edit") setMode("Add");
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err);
        toast.error(mode === "Edit" ? "Failed to update question" : "Failed to add question");
      });
  };

  const [loading, setLoading] = useState(true);
  // Table columns
  const confirmDelete = () => {
    if (!watch("selectedRow")) return;

    setLoading(true);
    console.log("Sel", watch("selectedRow"));

    deleteQuestionAPI(watch("selectedRow").id)
      .then((res) => {
        setLoading(false);
        setShowDeleteModal(false);

        if (res.data.status === true) {
          toast.success(res.data.message);
          getQuestions();
          setValue("selectedRow", "");
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Failed to delete question");
      });
  };
  const handleDeleteClick = (row) => {
    setValue("selectedRow", row);
    trigger("selectedRow");
    setLoading(false);
    setShowDeleteModal(true);
    console.log("dele",row)
  };
  const confirmApprove = () => {
    if (!watch("selectedRow")) return;

    setLoading(true);
    console.log("Sel", watch("selectedRow"));

    approveQuestionAPI(watch("selectedRow").id)
      .then((res) => {
        setLoading(false);
        setShowDeleteModal(false);

        if (res.data.status === true) {
          toast.success(res.data.message);
          getQuestions();
          setValue("selectedRow", "");
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Failed to delete question");
      });
  };
  const serverSideSearch = (data) => {
    const body = {
      search: watch("server_search"),
      page: currentPage,
      limit: itemPerPage,
    };
    console.log("pay", body);
    return;
    
  };
  useEffect(() => {
    if (watch("server_search")?.length == 0) {
      serverSideSearch();
    }
  }, [watch("server_search")]);
  return (
    <>
      <Head title="Question" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Rejected Question</BlockTitle>
            </BlockHeadContent>
            {isOpen ? (
              <BlockHeadContent>
                <Button
                  color="primary"
                  outline
                  onClick={() => {
                    setIsOpen((prev) => !prev);
                    reset();
                    setMode("Add");
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </BlockHeadContent>
            ) : null}
          </BlockBetween>
        </BlockHead>

        <QuestionCountsCards />

        {isOpen && (
          <PreviewAltCard>
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row>
                <Col md="4">
                  <MyCreateSelect
                    register={register("keyword", { required: "At least one keyword required" })}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Keyword"
                    name="keyword"
                    placeholder="Enter keyword"
                    required
                    multi
                  />
                </Col>
                <Col>
                  <MyCreateSelect
                    register={register("category", { required: "At least one category required" })}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Category"
                    name="category"
                    placeholder="Enter category"
                    required
                    multi
                  />
                </Col>
                {/* <Col md="4">
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Category"
                    name="category"
                    placeholder="Select category"
                    required
                    options={[
                      { value: "Women Safety", label: "Women Safety" },
                      { value: "Child Safety", label: "Child Safety" },
                      { value: "Health", label: "Health" },
                    ]}
                  />
                </Col> */}
                <Col md="4">
                  <MyCreateSelect
                    register={register("questions", { required: "At least one question required" })}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Questions"
                    name="questions"
                    placeholder="Add questions"
                    required
                    multi
                  />
                </Col>
                <Col md="4">
                  <MyCreateSelect
                    register={register("helpline_numbers", {
                      required: "Enter at least one helpline number",
                      validate: (values) => {
                        const invalid = values.find((v) => !/^\d{3}$/.test(v));
                        return invalid ? `Invalid number: ${invalid}` : true;
                      },
                    })}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Helpline Number"
                    name="helpline_numbers"
                    placeholder="Enter helpline number"
                    required
                    multi
                  />
                </Col>
                <Col md="4">
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Department"
                    name="department"
                    placeholder="Select department"
                    required
                    options={[
                      { value: "Women Safety", label: "Women Safety" },
                      { value: "Child Safety", label: "Child Safety" },
                      { value: "Health", label: "Health" },
                    ]}
                  />
                </Col>
                <Col md="4">
                  <EmailCreatableSelect
                    register={register("email", {
                      required: "Enter at least one email",
                      validate: (values) => {
                        const invalid = values.find((v) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v));
                        return invalid ? `Invalid email: ${invalid}` : true;
                      },
                    })}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Email"
                    name="email"
                    placeholder="Enter email"
                    required
                    multi
                  />
                </Col>
                <Col md="4">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Website"
                    name="website"
                    placeholder="Enter website URL"
                  />
                </Col>
                <Col md="12">
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Short Answer"
                    name="answer_short"
                    placeholder="Enter short answer"
                    required
                    row={2}
                  />
                </Col>
                <Col md="12">
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Detailed Answer"
                    name="answer_detail"
                    placeholder="Enter detailed answer"
                    required
                    row={2}
                  />
                </Col>
                {mode == "Add" || mode == "Edit" ? (
                  <Col md="12" className="d-flex justify-content-end mt-3">
                    <MyButton isLoading={isLoading} mode={mode} />
                  </Col>
                ) : mode == "Approve" ? (
                  <div className="d-flex">
                  <Col md="12" className="d-flex">
                    <div className="form-group me-1" style={{ marginTop: "31px" }}>
                      <Button disabled={isLoading} color="primary" size="md">
                        {isLoading ? <Spinner size="sm" color="light" /> : "Approve"}
                      </Button>
                    </div>
                    <div className="form-group" style={{ marginTop: "31px" }}>
                      <Button type="button" onClick={()=>handleDeleteClick(watch("selectedRow")?.selectedRow)} disabled={isLoading} color="danger" size="md">
                        {isLoading ? <Spinner size="sm" color="light" /> : "Reject"}
                      </Button>
                    </div>
                  </Col>                   
                  </div>
                ) : (
                  ""
                )}
              </Row>
            </Form>
          </PreviewAltCard>
        )}

        {/* <MyDataTable data={data} columns={columns} title="Pending Questions" isLoading={isLoading} /> */}
        <ApiPaginationDataTable
          data={data}
          setSearchText={setSearchText}
          onSearchText={onSearchText}
          onSearch={onSearch}
          setonSearch={setonSearch}
          limit={limit}
          totalRows={limit}
          setItemPerPage={setItemPerPage}
          itemPerPage={itemPerPage}
          perPage={itemPerPage}
          paginate={paginate}
          currentPage={currentPage}
          columns={columns}
          title={"Rejected Questions"}
          isLoading={isLoading}
          register={register}
          trigger={trigger}
          watch={watch}
          setValue={setValue}
          errors={errors}
          serverSearch
          serverSideSearch={serverSideSearch}
          paginationServer
          handlePageChange={handlePageChange}
          handlePerRowsChange={handlePerRowsChange}
          expo
          expKeys={["keyword","category","questions","answer_short","answer_detail"]}
          fileName={"Rejected Questions"}
        />
        <DeleteModal
          showDeleteModal={showDeleteModal}
          setShowDeleteModal={setShowDeleteModal}
          confirmDelete={confirmDelete}
          selectedRow={selectedRow}
          loading={loading}
        />
      </Content>
    </>
  );
};

export default RejectedQuestion;